import * as React from 'react'
import { useEffect, useRef, useState } from 'react'

import { Comment, EditorContainer } from '../components'
import { Conversation as IConversation, Comment as IComment } from '../dtos'
// import { TributeComponentParams } from '../../rich-text-editor'

export interface OptionsProps {
    canBookmarkComment?: boolean
    canDislike?: boolean
    canLike?: boolean
    isChronologicalOrder?: boolean
}

export interface ConversationProps {
    addComment: (comment: IComment, callback?: () => void) => void
    bookmarkComment: (commentId: string) => void
    conversation: IConversation
    dislikeComment: (commentId: string) => void
    editComment: (comment: IComment, callback?: () => void) => void
    likeComment: (commentId: string) => void
    options?: OptionsProps
    user: { id: string }
    talkRef: (ref: React.MutableRefObject<any>) => void
    onLinkClick?: (url: string) => void
    getTributeComponent: any
    tributes?: Array<any>
}

export const Conversation: React.FC<ConversationProps> = (props) => {
    const {
        conversation,
        getTributeComponent,
        onLinkClick,
        talkRef,
        tributes
    } = props
    const conversationRef = useRef(null)

    useEffect(() => {
        talkRef && talkRef(conversationRef)
    }, [conversationRef, conversation])
    // public static defaultProps = {
    //     options: {
    //         canBookmarkComment: true,
    //         canDislike: false,
    //         canLike: true,
    //         isChronologicalOrder: true
    //     }
    // }

    const [showReplyEditorId, setShowReplyEditorId] = useState('')
    const [showEditEditorId, setShowEditEditorId] = useState('')
    const [editorCommentId, setEditorCommentId] = useState('')

    const requestedToShowReplyEditor = (commentId: string) => {
        setShowReplyEditorId(commentId)
        setShowEditEditorId('')
    }

    const requestedToShowEditEditor = (commentId: string) => {
        setShowEditEditorId(commentId)
        setShowReplyEditorId('')
    }

    const hideReplyEditor = () => {
        setShowReplyEditorId('')
    }

    const hideEditEditor = () => {
        setShowEditEditorId('')
    }

    const decorateCommentsWithExtraProperties = (comments: IComment[]) => {
        const decoratedComments: IComment[] = [...comments]
        // @ts-ignore
        if (props.options.isChronologicalOrder) {
            return decoratedComments
        } else {
            return decoratedComments.reverse()
        }
    }

    const loop = (comments: IComment[]): React.ReactNode => {
        return (
            // <ul className='RootCommentsUL'>
            comments.map((comment) => {
                return (
                    // <li>
                    <Comment
                        options={props.options}
                        likeComment={props.likeComment}
                        dislikeComment={props.dislikeComment}
                        bookmarkComment={props.bookmarkComment}
                        comment={comment}
                        user={props.user}
                        key={comment.id}
                        requestedToShowReplyEditor={requestedToShowReplyEditor}
                        requestedToShowEditEditor={requestedToShowEditEditor}
                        onLinkClick={onLinkClick}
                        getTributeComponent={getTributeComponent}
                        // @ts-ignore
                        editEditor={
                            showEditEditorId === comment.id && (
                                <EditorContainer
                                    getTributeComponent={getTributeComponent}
                                    initialValue={comment.content}
                                    parentConversation={{
                                        id: comment.parentConversation.id
                                    }}
                                    hideEditEditor={hideEditEditor}
                                    editorType={'edit'}
                                    user={props.user}
                                    onAddComment={props.addComment}
                                    onEditComment={props.editComment}
                                    // @ts-ignore
                                    submitting={undefined}
                                    tributes={tributes}
                                    comment={comment}
                                />
                            )
                        }
                        // @ts-ignore
                        replyEditor={
                            showReplyEditorId === comment.id && (
                                <EditorContainer
                                    getTributeComponent={getTributeComponent}
                                    // @ts-ignore
                                    initialValue={null}
                                    parentConversation={{
                                        id: comment.parentConversation.id
                                    }}
                                    hideReplyEditor={hideReplyEditor}
                                    editorType={'reply'}
                                    user={props.user}
                                    onAddComment={props.addComment}
                                    onEditComment={props.editComment}
                                    // @ts-ignore
                                    submitting={undefined}
                                    tributes={tributes}
                                    comment={comment}
                                />
                            )
                        }
                    >
                        {loop(
                            // @ts-ignore
                            conversation.comments.filter(
                                (c) =>
                                    c.parentComment &&
                                    c.parentComment.id === comment.id
                            )
                        )}
                    </Comment>
                    // 		{/* </li> */}
                )
            })
            // {/* </ul> */}
        )
    }

    // @ts-ignore
    const rootComments = conversation.comments.filter(
        (c) => c.parentComment === null
    )

    const comments: IComment[] = decorateCommentsWithExtraProperties(
        rootComments
    )

    return (
        <div className="talk-conversation" ref={conversationRef}>
            <a id="top" href="#top" />
            {loop(comments)}
            <a id="lastComment" href="#lastComment" />
        </div>
    )
}
